import { Dropdown } from '@platform/ui-library';
import { useEffect, useState } from 'react';
import { Button } from '../../../form_components';
import { useDesign, useServices } from '../../../hooks';
import {
  Design,
  DesignChangeMap,
  Option
} from '../../../types';
import { createDesignChangeMap } from '../../../utilities/versioning';
import { MergeDialog, MergeDialogType } from '../../dialogs/MergeDialog';

export function ReviewContainer() {
  const { avsService, loadingService } = useServices();
  const { branchId } = useDesign();
  const [sourceSerialized, setSourceSerialized] = useState<Design>();
  const [sourceVersion, setSourceVersion] = useState<string>();
  const [targetChangeMap, setTargetChangeMap] = useState<DesignChangeMap | null>(null);
  const [targetSerialized, setTargetSerialized] = useState<Design>();
  const [targetVersion, setTargetVersion] = useState<string | null>(null);
  const [targetVersions, setTargetVersions] = useState<Option<string>[]>([]);
  const [versions, setVersions] = useState<Option<string>[]>([]);

  useEffect(() => {
    (async () => {
      ++loadingService.loadingCount;
      const versions = await avsService.getVersions(branchId);
      setVersions(versions.map(({ version }) => {
        return {
          label: version,
          value: version
        };
      }));
      --loadingService.loadingCount;
    })();
  }, [branchId]);

  useEffect(() => {
    const targetVersionsIdx = versions.findIndex(({ value }) => {
      return value === sourceVersion;
    });
    setTargetVersion(null);
    setTargetVersions(versions.slice(0, targetVersionsIdx));
  }, [sourceVersion]);

  const getVersions = async () => {
    if (!sourceVersion || !targetVersion) {
      return false;
    }

    ++loadingService.loadingCount;
    const [
      source,
      target
    ] = await Promise.all([
      avsService.getDesign(branchId, sourceVersion),
      avsService.getDesign(branchId, targetVersion)
    ]);
    setSourceSerialized(source);
    setTargetSerialized(target);
    const changeMap = createDesignChangeMap(target, source);

    setTargetChangeMap(changeMap);
    --loadingService.loadingCount;
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'flex-start', margin: '0 1em' }}>
        <div style={{ flex: 1, padding: '0 1em' }}>
          <label>1. Select Source</label>
          <Dropdown
            displayText={sourceVersion ?? 'Select Source to Compare From'}
            // Remove the latest version because target must be newer.
            options={Option.toDropdownOptions(versions.slice(1))}
            onChange={(newVersion) => {
              setTargetChangeMap(null);
              setSourceVersion(newVersion);
            }}
            value={sourceVersion}
          />
        </div>
        <div style={{ flex: 1, padding: '0 1em' }}>
          {(!targetVersions.length) ? null : (
            <>
              <label> 2. Select Target</label>
              <Dropdown
                displayText={targetVersion ?? 'Select Target to Compare To'}
                onChange={(newVersion) => {
                  setTargetChangeMap(null);
                  setTargetVersion(newVersion);
                }}
                options={Option.toDropdownOptions(targetVersions)}
                value={targetVersion ?? undefined}
              />
              <div style={{ color: 'var(--theme-text-muted)', paddingLeft: '.4em', paddingTop: '.2em' }}>(must be newer than Source)</div>
            </>
          )}
        </div>
        <div style={{ flex: .25, padding: '0 1em', alignSelf: 'center' }}>
          {(!targetVersion) ? null : (
            <Button label="Review" callback={getVersions} />
          )}
        </div>
      </div>
      <div className="diff_container">
        {(!targetChangeMap) ? null : (
          <MergeDialog
            sourceChangeMap={{}}
            sourceDesign={sourceSerialized}
            targetChangeMap={targetChangeMap}
            targetDesign={targetSerialized}
            type={MergeDialogType.review}
          />
        )}
      </div>
    </>
  );
}
